import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Scrollbar } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { PropertyGrid } from "./PropertyGrid";
import { getFocus, useGet } from "state/jotai";
import { _bootstrap } from "state/store.bootstrap";
import { boostrap } from "state/store.fullEido";
import { useOpenHouseDrawer } from "components/Contact/useOpenHouseDrawer";
import "swiper/css";
import "swiper/css/scrollbar";

export const PropertySlider = ({ PropertySlider: ps }) => {
  const theme = useTheme();

  // Breakpoint checks
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLargeDesktop = useMediaQuery("(min-width:1330px)");
  const isVeryLarge = useMediaQuery("(min-width:1631px)");
  const eidoData = useGet(boostrap);
  const dropdownOption = getFocus(_bootstrap, "projectnames");

  const getResponsivePadding = () => {
    if (isVeryLarge) return "0 0px";
    if (isLargeDesktop) return "0 24px";
    if (isMobile) return "0 16px";
    return "0 24px"; // tablet/mid
  };

  // ✅ Determine heading label dynamically
  const labelKey =
    ps?.Properties?.length === 1
      ? "LedigeBoligerISkovlunden" // if only one property
      : "Ejendomme"; // otherwise default

  // console.log("labelPropertiesWebsite:", eidoData?.labelPropertiesWebsite);
  const headingLabel = eidoData?.labelPropertiesWebsite?.find(
    (btn) => btn.UILabelProperty === labelKey
  )?.Label;
    // console.log(headingLabel,"sksk")
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        "& .property-units-slider": { marginBottom: "14px" },
        paddingBottom: "80px",
      }}
    >
      {/* Heading */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "1440px",
          margin: "0 auto",
          padding: getResponsivePadding(),
        }}
      >
        <div className="h3">{headingLabel}</div>
      </Box>

      {/* Slider */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "1440px",
          margin: "0 auto",
          padding: getResponsivePadding(),
        }}
      >
        <Swiper
          modules={[Scrollbar]}
          slidesPerView="auto"
          spaceBetween={isMobile ? 15 : 8}
          scrollbar={{ draggable: true }}
        >
          {ps?.Properties?.map((data, i) => (
            <SwiperSlide
              className="property-units-slider"
              key={i}
              style={{
                width: "fit-content",
                height: "auto",
                borderRadius: "16px",
                overflow: "hidden",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backdropFilter = "blur(6px)";
                e.currentTarget.style.transform = "scale(1.01)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backdropFilter = "none";
                e.currentTarget.style.transform = "none";
              }}
            >
              <PropertyGrid data={data} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>
  );
};
